export const FETCH_CUSTOMER_LIST_PENDING = "FETCH_CUSTOMER_LIST_PENDING";
export const FETCH_CUSTOMER_LIST_REJECTED = "FETCH_CUSTOMER_LIST_REJECTED";
export const FETCH_CUSTOMER_LIST_FULFILLED = "FETCH_CUSTOMER_LIST_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/customerList.js